<template>
    <Navbar />
  <div id="eyejack-edu-page">
    <Header :content="myStore.headerContent" />
    <FullWidthVideo
      :videoURL="'https://player.vimeo.com/video/279589824?color=ffffff&byline=0&portrait=0'"
    />

    <div class="feature container" id="features">
      <SplitColumn :content="myStore.features.feature1" :direction="'left'" />
      <SplitColumn :content="myStore.features.feature2" :direction="'right'" />
      <SplitColumn :content="myStore.features.feature3" :direction="'left'" />
    </div>

    <div class="exhibitions">
      <div class="titles container">
        <h1>Student Exhibitions</h1>
        <hr />
        <p>
          Inspire students, teachers, parents and the community by creating AR
          exhibitions which showcase student work.
        </p>
      </div>
      <FullWidthVideo
        :videoURL="'https://player.vimeo.com/video/591332458?color=ffffff&byline=0&portrait=0'"
      />
    </div>

    <div class="educate" id="educators">
      <div class="educators container">
        <div class="titles">
          <h1>
            Meet the Educators <br />
            using EyeJack Creator
          </h1>
          <hr />
        </div>
        <Educator :educator="myStore.educators.educator1" :direction="'left'" />
        <Educator
          :educator="myStore.educators.educator3"
          :direction="'right'"
        />
        <Educator :educator="myStore.educators.educator2" :direction="'left'" />
      </div>
    </div>

    <div class="resources container" id="resources">
      <div class="resource-content">
        <div class="titles">
          <h1>Learning Resources</h1>
          <hr />
        </div>
        <SplitColumn :content="myStore.resources.step1" :direction="'left'" />
      </div>
    </div>

    <div class="pricing" id="pricing">
      <div class="pricing-content container">
        <div class="titles">
          <h1>Education Discounts</h1>
          <p>
            We offer discounts on the EyeJack Creator, Artist Plan for student
            groups of different sizes.
          </p>
        </div>
        <Table v-if="!tabletView" :content="myStore.table" />
        <div v-if="tabletView" class="pricing-card-wrapper">
          <PricingCard>
            <div class="card-header">
              <div v-html="myStore.table.head[0]" />
            </div>
            <div class="card-content">
              <p
                v-for="body in myStore.table.bodyRegular"
                :key="body"
                v-html="body[0]"
              />
              <p
                class="light"
                v-for="body in myStore.table.bodyLight"
                :key="body"
                v-html="body[0]"
              />
            </div>
            <hr />

            <h2 class="card-price" v-html="myStore.table.price[0]"></h2>
          </PricingCard>
          <PricingCard>
            <div class="card-header">
              <div v-html="myStore.table.head[1]" />
            </div>
            <div class="card-content">
              <p
                v-for="body in myStore.table.bodyRegular"
                :key="body"
                v-html="body[0]"
              />
              <!-- <p
                class="light"
                v-for="body in myStore.table.bodyLight"
                :key="body"
                v-html="body[1]"
              /> -->
              <!-- <p class="light">{{myStore.table.bodyLight[0][0]}}</p> -->
              <p class="light" style="font-weight: bold">{{myStore.table.bodyLight[0][1]}}</p>
              <p class="light" v-html="myStore.table.bodyLight[1][0]"></p>
              <p class="light" v-html="myStore.table.bodyLight[2][0]"></p>
            </div>
            <hr />
            <Button class="table-button" style="margin: 1.8em auto 1.8em auto" :link="'mailto:info+edu@eyejackapp.com'">{{myStore.table.price[1]}}</Button>
            <!-- <h2 class="card-price" v-html="myStore.table.price[1]"></h2> -->
          </PricingCard>
        </div>
      </div>
      <div class="test">
        <!-- <div class="white-space" /> -->
        <div class="header-subcontent container">
      <div class="special-offer-burst">
        <p>Special Offer</p>
        <p style="font-weight: bold;">USD $29.95*</p>
        <p>(per annual student licence)</p>
      </div>
      
    </div>
        <!-- <Button :link="'mailto:info+edu@eyejackapp.com'">Enquire</Button> -->
      </div>
    </div>

    <div class="download">
      <div class="container">
        <div class="download-content ">
        <h1>{{ myStore.download.coverTitle }}</h1>
        <Button :link="myStore.download.link">{{
          myStore.download.button
        }}</Button>
      </div>
      </div>
    </div>

    <div class="clients container">
      <div class="grid-container">
        <div
          v-for="client in myStore.clients"
          :key="client.logo"
          class="client-logos"
        >
          <div class="logo-item"><img :src="client.logo" /></div>
        </div>
      </div>
    </div>

    <div class="FAQ" id="FAQs">
      <div class="faq-content container">
        <div class="titles">
          <h1>FAQs</h1>
        </div>
        <div class="faqs">
          <FAQ
            v-for="(faq, i) in myStore.faqs"
            :faq="faq"
            :index="i"
            :key="i"
            :open="faq.open"
            @toggleOpen="toggleOpen"
          />
        </div>
      </div>
    </div>

    <Footer />

    <!-- <Tile :content="myStore.download" /> -->

    <!-- <Tile :content="myStore.caseStudy.case1" />
    <FullWidthVideo />
    <Tile :content="myStore.caseStudy.case2" />
    <div class="case-container container">
      <SplitColumn :content="myStore.caseStudy.case2" :direction="'left'" />
    </div>
 -->
  </div>
</template>

<script>
import Navbar from "./components/Navbar.vue";
import Header from "./components/Header.vue";
import Educator from "./components/Educator.vue";
// import Tile from "./components/Tile.vue";
import FullWidthVideo from "./components/FullWidthVideo.vue";
import SplitColumn from "./components/SplitColumn.vue";
import Table from "./components/Table.vue";
import PricingCard from "./components/PricingCard.vue";
import Button from "./components/Button.vue";
import FAQ from "./components/FAQ.vue";
import Footer from "./components/Footer.vue";
import store from "./stores";
import { ref, onMounted, onUnmounted, provide } from "vue";

export default {
  name: "eyejack-edu-page",
  components: {
    Navbar,
    Header,
    Educator,
    // Tile,
    FullWidthVideo,
    SplitColumn,
    Table,
    PricingCard,
    Button,
    FAQ,
    Footer,
  },
  setup() {
    const myStore = ref(store);
    const mobileView = ref(false);
    const tabletView = ref(false);
    console.log(store);
    const handleView = () => {
      mobileView.value = window.innerWidth < 1075;
      tabletView.value = window.innerWidth < 768;

    };

    handleView();
    onMounted(() => window.addEventListener("resize", handleView));
    onUnmounted(() => window.removeEventListener("resize", handleView));

    const toggleOpen = (index) => {
      myStore.value.faqs = myStore.value.faqs.map((faq, i) => {
        if (index === i) {
          faq.open = !faq.open;
        } else {
          faq.open = false;
        }
        return faq;
      });
    };

    provide("mobileView", mobileView);

    return {
      myStore,
      toggleOpen,
      mobileView,
      tabletView
    };
  },
};
</script>

<style lang="scss">
@import "./styles/styles.scss";

.grid-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  .client-logos {
    flex: 0 1 15%;
    margin: 1.5em;
  }
}
.test {
  background: #f4f4f4;
  display: flex;
  justify-content: center;
  align-items: center;
  .white-space {
    margin: 0 auto 15.125em auto;
    
  }
}

.pricing-card-wrapper {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
}

.titles {
  font-size: 0.58em;
  p {
    margin-top: 1em;
  }
}

.download {
  background: linear-gradient(180deg, #e95557 0%, #ec4878 100%);
  .download-content {
    font-size: 0.58em;
    h1 {
      color: #fff;
      text-align: center;
      padding-bottom: 0.58em;
    }
    .button {
      border-color: #fff;
      margin-left: auto;
      a {
        color: #fff;
      }
      &:hover {
        background: #fff;
        a {
          color: #e95557;
        }
      }
    }
  }
}

.educate {
  background: #fafafa;
  width: 100vw;
  padding-top: 1.5em;
  .educators {
    max-width: 1240px;
    width: 100%;
  }
}

.pricing {
  background: #f4f4f4;
  width: 100vw;
  .pricing-content {
    .titles {
      p {
        margin: 1em auto;
        width: 100%;
      }
    }
  }
}

.exhibitions {
  .titles {
    padding-bottom: 0;
    p {
      width: 100%;
      margin: 1em auto 2em auto;
    }
  }
}

.FAQ {
  .faq-content {
    max-width: 1021px;
    .titles {
      h1 {
        color: #fff;
      }
    }
  }
}

  .header-subcontent {
    padding-top: 0;
    // font-size: 0.7em;
    font-size: 1em;
    margin: 0 auto 0 auto;
   
    .special-offer-burst {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      font-size: 0.8em;
      // margin-left: 100px;
      margin: auto;
      margin-top: 2em;
      margin-top: 0;
      width: 100%;
      box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);
      // width: 200px;
      // height: 200px;
       width: 235px;
      height: 235px;
      border-radius: 50%;
      background-color: #e95557;
     
      p {
        color: white;
        text-align: center;

      }
    }
  }


@include media(">=phone-md") {
  .FAQ {
    font-size: 1em;
  }
  .test {
    background: white;

    margin: -200px auto auto auto;
    .button {
      margin: 12.5em auto 6.25em auto;
    }
  }

  .titles {
    font-size: 1em;
    p {
      text-align: center;
    }
  }
  .feature {
    font-size: 1em;
  }

  .educate {
    .educators {
      font-size: 1em;
    }
  }

  .download {
    .download-content {
      font-size: 1em;

      h1 {
        padding-bottom: 1.2em;
      }
    }
  }

  .header-subcontent {
    margin: 150px auto 0 auto;
    .special-offer-burst {
      margin-top: 2em;

    }
  }
}

@include media(">=desktop") {
  .pricing {
    .pricing-content {
      .titles {
        p {
          width: 58%;
        }
      }
    }
  }
  .exhibitions {
    .titles {
      p {
        width: 75%;
      }
    }
  }
}


</style>
